import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { twMerge } from "tailwind-merge";
var SavedSearchTag = function SavedSearchTag(_ref) {
  var title = _ref.title,
    onDelete = _ref.onDelete,
    _ref$haveDelete = _ref.haveDelete,
    haveDelete = _ref$haveDelete === void 0 ? false : _ref$haveDelete;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: twMerge("inline-flex gap-2 items-center border border-primary border-solid p-2 rounded-full w-fit bg-neutral-0 min-w-14 justify-center", haveDelete ? "hover:opacity-85 transition-opacity ease-in " : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm font-normal"
  }, title), haveDelete && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer",
    onClick: function onClick() {
      onDelete && onDelete();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/close-primary.svg",
    alt: "close"
  })))));
};
export default SavedSearchTag;